import axios from 'axios'
import qs from 'qs'
import {analytics} from '@/app/js/analytics'

class Cart {
  constructor() {
    this.quantityEls = document.querySelectorAll('.js-cart-quantity')
  }

  add(productId, quantity, option) {
    return this.fetchCart('add', {
      product_id: productId,
      quantity,
      option
    })
      .then(response => {
        this._updateQuantities(response)

        if (!Object.hasOwnProperty.call(response.data, 'product_info')) {
          console.error('Product not found!')
          return
        }

        analytics.productAddToCart(response.data.product_info, quantity)
      })
  }

  update(cartId, quantity) {
    return this.fetchCart('edit', {
      cart_id: cartId,
      quantity
    })
      .then(response => {
        this._updateQuantities(response)
        this._updateCartPopup(response.data)

        if (!Object.hasOwnProperty.call(response.data, 'product_info')) {
          console.error('Product not found!')
          return
        }

        if (parseInt(response.data.quantity_diff) > 0) {
          analytics.productAddToCart(response.data.product_info, Math.abs(response.data.quantity_diff))
        } else if (parseInt(response.data.quantity_diff) < 0) {
          analytics.productRemoveFromCart(response.data.product_info, Math.abs(response.data.quantity_diff))
        }
      })
  }

  delete(cartId) {
    return this.fetchCart('remove', {
      cart_id: cartId,
    })
      .then(response => {
        this._updateQuantities(response)
        this._updateCartPopup(response.data)
      })
  }

  _updateQuantities(response) {
    if (Object.hasOwnProperty.call(response.data, 'quantity')) {
      this.quantityEls.forEach(quantityEl => {
        quantityEl.textContent = response.data.quantity
      })
    }
  }

  async _updateCartPopup(data) {
    const cartPopupElement = document.querySelector('.js-cart-popup')
    if (!cartPopupElement) {
      return
    }
    const quantityElement = cartPopupElement.querySelector('.js-cart-popup-quantity')
    const totalElement = cartPopupElement.querySelector('.js-cart-popup-total')
    const freeShippingTextElement = cartPopupElement.querySelector('.js-cart-popup-free-shipping-text')
    const shippingInfoElement = cartPopupElement.querySelector('[data-shipping]')
    const giftInfoElement = cartPopupElement.querySelector('[data-gift]')
    const freeShippingAmount = shippingInfoElement.dataset.shipping
    const freeGiftAmount = giftInfoElement.dataset.gift

    if ('quantity' in data) {
      quantityElement.textContent = data.quantity
    }
    const {total, total_currency} = await this.getTotal()
    totalElement.textContent = total_currency
    shippingInfoElement.classList.remove('cart-popup__info-item_filled')
    giftInfoElement.classList.remove('cart-popup__info-item_filled')
    freeShippingTextElement.classList.add('cart-popup__row_hidden')
    if (total >= freeShippingAmount) {
      shippingInfoElement.classList.add('cart-popup__info-item_filled')
      freeShippingTextElement.classList.remove('cart-popup__row_hidden')
    }
    if (total >= freeGiftAmount) {
      giftInfoElement.classList.add('cart-popup__info-item_filled')
    }
  }

  fetchCart(url, data) {
    return axios({
      method: 'post',
      headers: {'content-type': 'application/x-www-form-urlencoded'},
      url: '/index.php?route=checkout/cart/' + url,
      data: qs.stringify(data),
    })
  }

  addUpsell(productId, upsellId, quantity = 1) {
    return this.fetchCart('addUpsell', {
      product_id: productId,
      upsell_id: upsellId,
      quantity,
    })
      .then(response => {
        this._updateQuantities(response)

        if (!Object.hasOwnProperty.call(response.data, 'product_info')) {
          console.error('Product not found!')
          return
        }

        analytics.productAddToCart(response.data.product_info, quantity)
      })
  }

  async getTotal() {
    const { data } = await axios({
      method: 'get',
      url: '/index.php?route=checkout/cart/total',
    })
    return data
  }

  async addVoucher(data) {
    const response = await axios({
      method: 'post',
      url: '/index.php?route=information/voucher/add',
      data
    })
    const responseData = response.data

    if (responseData && responseData.quantity) {
      this._updateQuantities(response)
    }
    return responseData
  }

  async removeVoucher(voucherId) {
    const response = await axios({
      method: 'get',
      url: `/index.php?route=information/voucher/remove&voucher_id=${voucherId}`
    })
    const responseData = response.data
    if (responseData && responseData.quantity) {
      this._updateQuantities(response)
    }
    return responseData
  }
}

export const cart = new Cart()
